import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

class PureWrapper extends React.PureComponent {
    render() {
        return <Fragment>{this.props.children}</Fragment>;
    }
}

PureWrapper.propTypes = {
    children: PropTypes.node
};

PureWrapper.defaultProps = {
    children: null
};

export default PureWrapper;
